import {Accordion, AccordionSummary, AccordionDetails, Stack, Typography, Chip} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import People from '@mui/icons-material/People';
import LocalShipping from '@mui/icons-material/LocalShipping';
import Constants from "../../../../utils/constants";
import TourneeCard from "./TourneeCard";
import Grid from "@mui/material/Grid2";

function OperateurAccordion({operateur, data, selectedDate, onTourneeDetailClick, onTourneeImpossibleClick, onMenuClick}) {
    return (
        <Accordion sx={{border: '1px solid lightgray'}}>
            <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                <Stack direction="row" spacing={2} justifyContent="space-between" width="100%">
                    <Stack direction="row" spacing={2}>
                        <Stack direction="row" spacing={1}>
                            <People sx={{color: Constants.COLOR_THEME_GREEN}} fontSize={"large"}/>
                            <Typography variant="h6">{operateur}</Typography>
                        </Stack>
                        <Stack direction="row" spacing={1}>
                            <LocalShipping sx={{color: Constants.COLOR_THEME_GREEN}} fontSize={"large"}/>
                            <Typography variant="h6">{data?.laveuse?.description || "Pas de véhicule"}</Typography>
                        </Stack>
                    </Stack>

                    <Stack direction="row" spacing={1}>
                        <Chip label={`${data.totalTours} tournée(s)`}/>
                        <Chip label={`${data.totalALaver} bacs`}
                              sx={{backgroundColor: Constants.COLOR_THEME_BLUE, color: 'white'}}/>
                        <Chip label={`${data.totalBacsLaves} lavé(s)`}
                              sx={{backgroundColor: Constants.COLOR_THEME_GREEN, color: 'white'}}/>
                        {data.totalBacsImpossible > 0 &&
                            <Chip label={`${data.totalBacsImpossible} impossible(s)`}
                                  sx={{backgroundColor: Constants.COLOR_THEME_RED, color: 'white'}}/>
                        }
                    </Stack>
                </Stack>
            </AccordionSummary>

            <AccordionDetails>
                <Grid container size={12} spacing={2}>
                    {data?.tours?.map((tournee, idx) => (
                        <Grid size={{xs: 12, md: 6, lg: 6}} key={idx}>
                            <TourneeCard
                                data={tournee}
                                selectedDate={selectedDate}
                                withHeader={true}
                                withProductivite={true}
                                onMenuClick={(e) => onMenuClick(e, tournee)}
                                onTourneeDetailClick={() => onTourneeDetailClick(tournee.id, selectedDate)}
                                onTourneeImpossibleClick={() => onTourneeImpossibleClick(tournee.id, selectedDate, true)}/>
                        </Grid>
                    ))}
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
}

export default OperateurAccordion;
